<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelEvento"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'filter', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_evento', null);
        return;
      }
      this.isObject ? this.$emit('selectChange', 'id_evento', e) : this.$emit('selectChange', 'id_evento', e.id);
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option.id === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option.id === null);
        selectedActual = this.options.find((option) => option.id === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', selectedActual);
    },
    // {'filterName', 'filters'}
    setOptions(filter) {
      const params = this.selectFilter(filter || null);
      this.isLoading = true;
      this.$atenaList
        .getCommon(filter.filterName || 'opcoes_evento_geral', params)
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          const opt = this.buildOptions(filter.filterName || 'opcoes_evento_geral', res.data);
          this.options = this.options.concat(opt);
          this.setValue(this.nameField);
          // this.onChange();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro ao Carregar Dados',
            msgContent: 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        });
    },
    selectFilter(filter) {
      const filters = {
        opcoes_evento_geral: {
          columns: '*',
          filter: 'tipo_subevento = 2 and ' + filter.filters,
          order: 'titulo_evento'
        },
        opcoes_evento_resultado_geral: { columns: '*', filter: filter.filters, order: 'titulo_evento' }
      };
      return filters[filter.filterName || 'opcoes_evento_geral'];
    },
    buildOptions(filterName, data) {
      if (filterName === 'opcoes_evento_geral') {
        return data.map((elem) => {
          return {
            id: elem.vencedor_evento,
            nome: elem.vencedor_evento
          };
        });
      } else {
        const opt = {
          casa: data[0].nome_casa,
          fora: data[0].nome_fora
        };

        return [
          { id: 1, nome: opt.casa },
          { id: 2, nome: opt.fora },
          { id: 3, nome: 'Empate' }
        ];
      }
    },
    labelEvento({ nome }) {
      return `${nome}`;
    }
  },

  watch: {
    filter(newVal, oldVal) {
      if (newVal.filterName !== oldVal.filterName) {
        this.setOptions(newVal);
      }
    }
  },

  created() {
    if (this.filter) this.setOptions(this.filter);
  }
};
</script>

<style lang="scss" scoped></style>
